/**
 * Rule-based bulk apply: gateway + TLD must come from template or bulk bar
 * For Media Devoted | Created By Ciro Autiero
 */

import type { Preset } from './types';

function templateRouteId(template: Record<string, unknown> | undefined): number {
  const raw = template?.routeId;
  return typeof raw === 'number' && Number.isFinite(raw) && raw > 0 ? raw : 0;
}

function templateTld(template: Record<string, unknown> | undefined): string {
  const v = template?.shortLinkTldValue;
  return typeof v === 'string' ? v.trim() : '';
}

/** True when apply API needs routeId + shortLinkTldValue (not both on template). */
export function ruleBasedPresetNeedsApplyRouting(preset: Preset): boolean {
  if (preset.presetType !== 'rule-based') return false;
  const t = preset.template;
  return templateRouteId(t) < 1 || templateTld(t).length === 0;
}

export function anyPresetNeedsBulkRouting(presets: Preset[]): boolean {
  return presets.some(ruleBasedPresetNeedsApplyRouting);
}
